export default "__VITE_ASSET__Jvh_8JXd6yzQXKgTTd8z1w__";